export default __webpack_public_path__ + "static/media/033-packages-1.2998b1f0.png";